import Bowser from 'bowser';

/**
 * Returns true if high fidelity, or false if low fidelity
 */
const calculateFidelityLevel = (): boolean => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const isAndroidSevenOrLess =
    browser.getOSName() === 'Android' &&
    Number(browser.getOSVersion().split('.').shift()) <= 7;
  const isHighFidelity = !isAndroidSevenOrLess;
  return isHighFidelity;
};

export default calculateFidelityLevel;
